import * as angular from 'angular';

class NetworkPointBundleCreateAuctionSettingsCtrl implements ng.IController {
    constructor() {}

    public bundleRequest: BundleChangeRequestDto;
    public exitNetworkPoint: NetworkPointDto;
    public entryNetworkPoint: NetworkPointDto;
    public editableDirection: Direction;
    public useShortTermForLongTerm: boolean;
    public isCreateMode: boolean;
    public readonly: boolean;

    $onInit() {}
}

angular.module('app').component('pkpNetworkPointBundleCreateAuctionSettings', {
    controller: NetworkPointBundleCreateAuctionSettingsCtrl,
    template:
        require('app/network-point-bundle/network-point-bundle-create-auction-settings.component.html'),
    bindings: {
        form: '=',
        readonly: '<',
        editableDirection: '<',
        bundleRequest: '=',
        exitNetworkPoint: '<',
        entryNetworkPoint: '<',
        useShortTermForLongTerm: '=',
        isCreateMode: '<'
    }
});
